import React from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const QueryParamsTab = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h6" gutterBottom>Query Parameters</Typography>
            <Typography variant="body1">
                Add key-value pairs to append to your URL for filtering, sorting, and more.
                Example: <code>?page=2&limit=20</code>
            </Typography>
            <img
                src="/send-requests/Params.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
        </Box>
    )
};

export default QueryParamsTab;
